// Input: "Category Name"
// Output: "Category-Name"

// There is a unique case where some tags are already hyphenated, so we need to replace the hyphen with a tilde
const getNormalizedCategory = (category: string) => {
  if (!category) return '';

  const replacedValue = category.replace(/-/g, '~').replace(/ /g, '-');

  if (typeof window === 'undefined' || !window.encodeURIComponent) {
    return replacedValue;
  }

  return window.encodeURIComponent(replacedValue);
};

export default getNormalizedCategory;
